export default "__VITE_ASSET__CrlMnyxY__"